import React, { useEffect } from 'react';
import { Platform } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';
import { v4 as uuidv4 } from 'uuid';
import CompetitionsScreen from './src/screens/CompetitionsScreen';
import { SessionProvider } from './src/context/SessionContext';
import CompetitionTabs from './src/screens/CompetitionTabs/CompetitionTabs';
import { BLUE, CARD } from './src/theme/colors';
import { logEvent } from './src/api/client';

const FIRST_OPEN_KEY = 'sg_first_open_sent';

const Stack = createNativeStackNavigator();

export default function App() {
  useEffect(() => {
    (async () => {
      try {
        const sent = await AsyncStorage.getItem(FIRST_OPEN_KEY);
        if (sent) return;
        const sessionId = uuidv4();
        const appVersion: string = Constants.expoConfig?.version ?? Constants.manifest?.version ?? '1.0.0';
        const platform = Platform.OS;
        await logEvent(
          { event_type: 'first_open', metadata: { platform, app_version: appVersion } },
          sessionId,
        );
        await AsyncStorage.setItem(FIRST_OPEN_KEY, '1');
      } catch {
        // Best-effort
      }
    })();
  }, []);

  return (
    <SessionProvider>
      <NavigationContainer>
        <Stack.Navigator
          screenOptions={{
            headerStyle: { backgroundColor: BLUE },
            headerTintColor: CARD,
            headerTitleStyle: { fontWeight: '700' },
            headerShadowVisible: false,
          }}
        >
          <Stack.Screen name="Competitions" component={CompetitionsScreen} options={{ title: 'Smart Gymnastics' }} />
          <Stack.Screen name="CompetitionTabs" component={CompetitionTabs} options={{ headerShown: false }} />
        </Stack.Navigator>
      </NavigationContainer>
    </SessionProvider>
  );
}
